var SPACE_LIST = ["xs", "sm", "md", "lg", "xlg", "xxlg", "xxxlg"];
var BRAND_COLORS = {
    "primary": "#12aa9c",
    "secondary": "#6f42c1",
    "success": "#20c997",
    "info": "#17a2b8",
    "warning": "#fadb14",
    "danger": "#dc3545",
};
var SPACE_SIZE = {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xlg: "20px",
    xxlg: "24px",
    xxxlg: "32px"
};
var designs = {
    SPACE_SIZE: SPACE_SIZE,
    SPACE_LIST: SPACE_LIST,
    BRAND_COLORS: BRAND_COLORS
};
export { designs, SPACE_SIZE, SPACE_LIST, BRAND_COLORS };
